<template>
  <div id="BiddingDetailComponent">
    <v-card outlined>
      <v-card-text>
        <v-tabs v-model="isTabs" v-if="isRound > 0">
          <v-tabs-slider></v-tabs-slider>
          <v-tab v-for="(item, index) in dataBiddingDetailSub" :key="index">
            {{
              index === 0
                ? "First Submit"
                : `Negotiation #${item.biddingRound - 1}`
            }}
          </v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="isTabs">
          <v-tab-item
            v-for="(item, index) in dataBiddingDetailSub"
            :key="index"
          >
            <v-card flat>
              <v-card-text>
                <v-form :ref="`form${isRound}`" v-model="valid" lazy-validation>
                  <v-row align="center" class="pa-4"
                    >
                    <v-col cols="3"
                      ><v-text-field
                        :disabled="!checkEdit(item.biddingRound, isEdit)"
                        outlined
                        v-model="item.deliveryTime"
                        label="Delivery Time (Day)"
                        dense
                        required
                        :rules="[
                          (v) => !!v || ' Delivery Time (Day) is required',
                        ]"
                        v-mask="'#############'"
                      ></v-text-field>
                    </v-col>
                  
  
                  
                 
               
              
                  
                    
                    <v-col cols="3"
                      ><v-text-field
                        :disabled="!checkEdit(item.biddingRound, isEdit)"
                        outlined
                        v-model="item.warranty"
                        label="Warranty (Day)"
                        dense
                        required
                        :rules="[(v) => !!v || 'Warranty (Day) is required']"
                        v-mask="'#############'"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3"
                      ><v-text-field
                        :disabled="!checkEdit(item.biddingRound, isEdit)"
                        outlined
                        v-model="item.paymentTerm"
                        label="Payment Term (Day)"
                        dense
                        required
                        :rules="[
                          (v) => !!v || 'Payment Term (Day) is required',
                        ]"
                        v-mask="'#############'"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6"
                      ><v-select
                        :disabled="!checkEdit(item.biddingRound, isEdit)"
                        outlined
                        dense
                        :required="!checkEdit(item.biddingRound, isEdit)"
                        :rules="[
                          (v) => !!v || 'INCO Term is required',
                        ]"
                        v-model="item.incoTerm"
                        :items="dataMasterIncoTerm"
                        label="INCO Term"
                        item-text="name"
                        item-value="incoTermId"
                      ></v-select>
                    </v-col>
                    <v-col cols="6"
                      ><v-text-field
                        :disabled="!checkEdit(item.biddingRound, isEdit)"
                        outlined
                        v-model="item.priceValid"
                        label="Price Valid (Day)"
                        dense
                        v-mask="'#############'"
                        :rules="[
                          (v) => !!v || 'Price Valid (Day) (Day) is required',
                        ]"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6"
                      ><v-text-field
                        :disabled="!checkEdit(item.biddingRound, isEdit)"
                        outlined
                        v-model="item.deviation"
                        label="Deviation"
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6"
                      ><v-text-field
                        :disabled="!checkEdit(item.biddingRound, isEdit)"
                        outlined
                        v-model="item.additionalInformation"
                        label="Additional Information"
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items> </v-card-text
    ></v-card>
  </div>
</template>

<script>
import { masterservice } from "../../../services/masterservice";

export default {
  name: "BiddingDetailComponent",
  props: {
    propBiddingDetail: {
      type: Array,
      default: null,
    },
    propBiddingStatus: {
      type: String,
      default: "",
    },
    propIsVendorValid: {
      type: Boolean,
      default: false,
    },
    propIsEdit: {
      type: Boolean,
      default: false,
    },
    propIsloadDetail: {
      type: Boolean,
      default: false,
    },
    propsIsTabs: {
      type: Number,
      default: () => 0,
    },
    propCheckStep: {
      type: [Number, String],
      default: () => "",
    },
  },
  data: () => ({
    activePicker: null,
    valid: true,
    dataBiddingDetailSub: [],
    dataMasterIncoTerm: [],
    selectedIncoTerm: {},
    isRound: 0,
    isEdit: false,
    isTabs: 0,
    menuPickerIdCard: false,
    activePickerIdCard: null,
  }),
  watch: {
    propIsloadDetail(value) {
      if (value) {
        this.$loading(true);
        Promise.all([this.setDataDetail()]).then(() => this.$loading(false));
      }
    },
    propIsEdit(value) {
      if (value) this.isEdit = value;
    },
    propsIsTabs(value) {
      this.isTabs = value;
    },
    isTabs() {
      this.callIsTab();
    },
    propCheckStep(value) {
      if (value === 2) {
        this.validate();
      }
    },
    menuPickerIdCard(val) {
      val && setTimeout(() => (this.activePickerIdCard = "YEAR"));
    },
  },
  updated() {
    this.$emit("emitBiddingDetail", this.dataBiddingDetailSub);
  },
  methods: {
    // onlyNumber(Str) {
    //   const reg = /^\d+$/;
    //   const result =  Str(reg)
    //   return result;
    // },
    async validate() {
      this.isTabs = this.isRound - 1;
      if (this.checkEdit(this.isRound, this.isEdit)) {
        await this.$refs[`form${this.isRound}`][0].validate();
        if (this.valid === true) {
          this.$emit("emitValidateDetail", true);
        } else {
          this.$emit("emitValidateDetail", false);
        }
      }
    },

    callIsTab() {
      this.$emit("callbackIsTab", this.isTabs);
    },
    checkEdit(isRound, isEdit) {
      const round = this.isRound === isRound ? true : false;
      if (round && isEdit) return true;
      else return false;
    },
    async setDataDetail() {
      Promise.all([this.getMasterIncoTerm()]).then(() => {
        if (this.propIsVendorValid) {
          this.setBiddingDetail();
        }
      });
      for (let i = 0; i < this.propBiddingDetail.length; i++) {
        const element = {
          deliveryTime: this.propBiddingDetail[i].deliveryTime,
          incoTerm: this.propBiddingDetail[i].incoTerm,
          paymentTerm: this.propBiddingDetail[i].paymentTerm,
          warranty: this.propBiddingDetail[i].warranty,
          deviation: this.propBiddingDetail[i].deviation,
          additionalInformation:
            this.propBiddingDetail[i].additionalInformation,
          biddingRound: this.propBiddingDetail[i].biddingRound,
          priceValid: this.propBiddingDetail[i].priceValid,
          deliveryDate:this.propBiddingDetail[i].deliveryDate,
        };
        this.dataBiddingDetailSub.push(element);
        console.log(this.dataBiddingDetailSub);
      }
      this.isRound =
        this.propBiddingDetail.length > 0
          ? this.propBiddingDetail[this.propBiddingDetail.length - 1]
              .biddingRound
          : 1;
    },
    async getMasterIncoTerm() {
      this.dataMasterIncoTerm = await masterservice.GetMasterIncoTerm();
    },
    async setBiddingDetail() {
      if (this.propBiddingDetail[this.isRound - 1] !== undefined) {
        this.$emit("emitBiddingDetail", this.dataBiddingDetailSub);
      }
      ///;
    },
  },
};
</script>
<style lang="scss" scoped>
.col {
  padding: 0 0.5rem;
}
</style>
